<template>
  <div :class="'survey-question self-center text-center survey-question-'+question.id">
    <div v-if="question.type == 'multiple'">
      <h2>{{ proccessedQuestion }}</h2>
      <p>{{ question.sub }}</p>
      <div class="multi-buttons self-center">
        <div v-for="option in question.options" :key="option.value" class="flex justify-center self-center">
          <button
            :class="{ selected: answer == option.value }"
            @click="(answer = option.value), next()"
          >
            <img
              v-if="option.topIcon"
              class="top-icon"
              :src="addUrlPrefix(option.topIcon)"
            />
            {{ option.text }}
            <div class="description" v-if="option.description">
              {{ option.description }}
            </div>
            <img
              v-if="option.bottomIcon"
              class="bottom-icon"
              :src="addUrlPrefix(option.bottomIcon)"
            />
          </button>
        </div>
      </div>
    </div>
    <div v-if="question.type == 'intro'">
      <div class="flex flex-col text-left mx-auto max-w-7xl justify-start items-center">
        <h1 class="text-2xl text-gray-600 text-center">So funktioniert's</h1>
        <div class="flex items-center justify-start opacity-0 animate-show w-96 max-w-full" style="animation-delay: 0.25s">
          <img class="w-32 mr-3" src="/icons/a.png">
          <div class="text-lg max-w-2xl">
            <b>Schritt 1</b><br>
            Online Fragebogen ausfüllen
            </div>
        </div>
        <div class="flex items-center justify-start opacity-0 animate-show w-96 max-w-full" style="animation-delay: 1.25s">
          <img class="w-32 mr-3" src="/icons/b.png">
          <div class="text-lg max-w-2xl">
            <b>Schritt 2</b><br>
            Persönliche Nahrungsmittel&shy;ergänzungsbox gestalten
            </div>
        </div>
        <div class="flex items-center justify-start opacity-0 animate-show w-96 max-w-full" style="animation-delay: 2.25s">
          <img class="w-32 mr-3" src="/icons/c.png">
          <div class="text-lg max-w-2xl">
            <b>Schritt 3</b><br>
            Entspannt nach Hause geliefert bekommen
            </div>
        </div>
      </div>
    </div>
    <div v-if="question.type == 'multiselect'">
      <h2>{{ proccessedQuestion }}</h2>
      <div class="multi-buttons">
        <div v-for="option in question.options" :key="option.value">
          <button
            :class="{ selected: answer.includes(option.value) }"
            @click="
              answer.includes(option.value)
                ? (answer = answer.filter((y) => y != option.value))
                : (answer.push(option.value),
                  answer.length > question.max ? answer.shift() : '')
            "
          >
            <img
              v-if="option.topIcon"
              class="top-icon"
              :src="addUrlPrefix(option.topIcon)"
            />
            {{ option.text }}
            <div class="description" v-if="option.description">
              {{ option.description }}
            </div>
            <img
              v-if="option.bottomIcon"
              class="bottom-icon"
              :src="addUrlPrefix(option.bottomIcon)"
            />
          </button>
        </div>
      </div>
    </div>
    <div v-else-if="question.type == 'range'">
      <h2>{{ proccessedQuestion }}</h2>
      <img
        v-if="question.leftIcon"
        class="left-icon"
        :src="addUrlPrefix(question.leftIcon)"
      />
      <input type="range" v-model="answer" />
      <img
        v-if="question.rightIcon"
        class="right-icon"
        :src="addUrlPrefix(question.rightIcon)"
      />
    </div>
    <div v-else-if="question.type == 'text'">
      <h2>{{ proccessedQuestion }}</h2>
      <input 
        style="width: 36rem;"
        class="px-2 py-1 text-center mt-8 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 block max-w-full border-gray-300 rounded-md"
        type="text" v-model="answer" :placeholder="question.ph" />
    </div>
    <div v-else-if="question.type == 'mail'">
      <h2>{{ proccessedQuestion }}</h2>
      <input 
        style="width: 36rem;"
        class="px-2 py-1 text-center mt-8 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 block max-w-full border-gray-300 rounded-md"
        type="email" v-model="answer" :placeholder="question.ph" />
        <span>

        </span>
        <div class="relative flex items-center max-w-xl mt-6 text-left mx-auto" >
        <div class="flex items-center justify-items-start h-5 content-start">
            <input @click="$set(question, 'accept', !question.accept)" id="emailaccept" name="emailaccept" type="checkbox" class="h-5 w-5 mx-0 text-orange-400 border-gray-300 rounded focus:ring-orange">
        </div>
        <div class="ml-3 text-sm cursor">
            <label for="emailaccept" class="font-bold">
              Durch Ankreuzen dieses Feldes akzeptiere ich, dass meine persönlichen Daten an GloryFeel übermittelt werden, um meine persönliche Nahrungsergänzung zu erstellen.
            </label>
        </div>
    </div>
    </div>
    <div v-else-if="question.type == 'number'">
      <h2>{{ proccessedQuestion }}</h2>
      <input 
        class="px-2 py-1 text-left mt-8 shadow-sm text-xl focus:ring-primary-500 border focus:border-primary-500 block max-w-xl border-gray-300 rounded-md"
        type="number" v-model="answer" :placeholder="question.ph" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyQuestion",
  props: {
    value: {},
    question: {
      type: Object,
      required: true,
    },
    answers: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answer: this.value,
    };
  },
  watch: {
    answer: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
  computed: {
    proccessedQuestion() {
      let question = this.question.question;
      for (let i in this.answers) {
        question = question.replace(
          new RegExp("{{" + i + "}}", "gi"),
          this.answers[i] || ""
        );
      }
      return question;
    },
  },
  methods: {
    next() {
      setTimeout(() => this.$emit("next"), 100);
    },
    addUrlPrefix(url) {
      return "https://gloryfeel-survey-2.web.app" + url;
    },
  },
  mounted() {
    if (this.question.type == "multiselect" && !Array.isArray(this.value)) {
      this.answer = [];
    }
  },
};
</script>

<style scoped>

/*:-moz-last-node
input {
  font-family: "Roboto", sans-serif;
  font-size: 2.4em;
  border: 2px solid #002c4d;
  padding: 8px 16px;
  border-radius: 0 !important;
  outline: none !important;
  max-width: calc(100% - 32px - 4px);
}*/

.multi-buttons {
  display: flex;
  margin: 32px 0;
  justify-content: center;
  flex-wrap: wrap;
  margin: 32px 0;
  outline: 0px;
  @apply max-w-4xl mx-auto
}

.multi-buttons > div {
  height: auto;
  margin: 8px 0;
  border: 0px;
  outline: 0px;
}


.survey-question p {
  color: #002c4d;
  font-size: 1.3em;
  text-transform: initial;
}

.multi-buttons .description {
  max-width: 230px;
  font-size: 16px;
  margin-top: 8px;
  outline: 0px;
  line-height: 1.1;
}

/*
button {
  background: transparent;
  border: 2px solid #002c4d;
  color: #002c4d;
  font-weight: bold;
  padding: 8px 16px;
  margin: 8px;
  display: block;
  cursor: pointer;
  font-size: 1.3em;
  border-radius: 0px;
  height: 100%;
  transition: all 0.5s ease;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 8px 22px 0 rgba(0, 0, 0, 0.19);
  border-radius: 20px;
  outline: 0px;
}

button:hover {
  background: #002c4d;
  border: 2px solid #002c4d;
  color: #ffffff;
  font-weight: bold;
  padding: 8px 16px;
  margin: 8px;
  display: block;
  cursor: pointer;
  font-size: 1.3em;
  height: 100%;
  transition: all 0.5s ease;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 8px 22px 0 rgba(0, 0, 0, 0.19);
  border-radius: 20px;
  outline: 0px;
}

.multi-buttons button.selected {
  background: #002c4d;
  border: 2px solid #002c4d;
  color: #ffffff;
  font-weight: bold;
  padding: 8px 16px;
  margin: 8px;
  display: block;
  cursor: pointer;
  font-size: 1.3em;
  height: 100%;
  transition: all 0.5s ease;
  box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.2), 0 8px 22px 0 rgba(0, 0, 0, 0.19);
  border-radius: 20px;
  outline: 0px;
}*/

.multi-buttons button{
  @apply flex-wrap text-lg text-primary h-auto transition-colors justify-center mx-2 items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-primary-700 bg-primary-100 hover:bg-primary hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500
}

.multi-buttons button.selected{
  @apply text-white bg-primary
}

img.top-icon {
  display: block;
  width: 64px;
  margin: 0 auto 8px auto;
  outline: 0px;
}

button:hover img.top-icon {
  display: block;
  width: 64px;
  margin: 0 auto 8px auto;
  filter: brightness(100);
  outline: 0px;
}

button.selected img.top-icon {
  display: block;
  width: 64px;
  margin: 0 auto 8px auto;
  filter: brightness(100);
  outline: 0px;
}

img.bottom-icon {
  display: block;
  width: 64px;
  margin: 8px auto 0 auto;
  outline: 0px;
}

img.left-icon {
  float: left;
  width: 64px;
}

img.right-icon {
  float: right;
  width: 64px;
}
input[type="range"] {
  width: 100%;
  margin: 12.4px 0;
  background-color: transparent;
  -webkit-appearance: none;
  border: none;
  width: calc(100% - 164px);
}
input[type="range"]:focus {
  outline: none;
}
input[type="range"]::-webkit-slider-runnable-track {
  background: #002c4d;
  border: 0;
  border-radius: 25px;
  width: 100%;
  height: 11.2px;
  cursor: pointer;
}
input[type="range"]::-webkit-slider-thumb {
  margin-top: -12.4px;
  width: 36px;
  height: 36px;
  background: #002c4d;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  -webkit-appearance: none;
}
input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #003b67;
}
input[type="range"]::-moz-range-track {
  background: #002c4d;
  border: 0;
  border-radius: 25px;
  width: 100%;
  height: 11.2px;
  cursor: pointer;
}
input[type="range"]::-moz-range-thumb {
  width: 36px;
  height: 36px;
  background: #002c4d;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
}
input[type="range"]::-ms-track {
  background: transparent;
  border-color: transparent;
  border-width: 12.4px 0;
  color: transparent;
  width: 100%;
  height: 11.2px;
  cursor: pointer;
}
input[type="range"]::-ms-fill-lower {
  background: #001d33;
  border: 0;
  border-radius: 50px;
}
input[type="range"]::-ms-fill-upper {
  background: #002c4d;
  border: 0;
  border-radius: 50px;
}
input[type="range"]::-ms-thumb {
  width: 36px;
  height: 36px;
  background: #002c4d;
  border: 0;
  border-radius: 50px;
  cursor: pointer;
  margin-top: 0px;
  /*Needed to keep the Edge thumb centred*/
}
input[type="range"]:focus::-ms-fill-lower {
  background: #002c4d;
}
input[type="range"]:focus::-ms-fill-upper {
  background: #003b67;
}
/* Responsive Webdesign */
@media screen and (max-width: 1000px) {
  h2 {
    font-size: 2em;
  }

  button {
    font-size: 1em;
    max-width: 150px;
    line-height: 1.5;
    hyphens: auto;
  }
  button:hover {
    font-size: 1em;
    max-width: 150px;
    line-height: 1.5;
    hyphens: auto;
  }
  .multi-buttons button.selected {
    font-size: 1em;
    line-height: 1.5;
    hyphens: auto;
  }
  .multi-buttons .description {
    font-size: 12px;
  }
  img.top-icon {
    width: 50px;
  }

  button:hover img.top-icon {
    width: 50px;
  }

  button.selected img.top-icon {
    width: 50px;
  }

  img.bottom-icon {
    width: 50px;
  }

  img.left-icon {
    width: 50px;
  }

  img.right-icon {
    width: 50px;
  }
}

h2{
  @apply text-xl md:text-4xl mt-6 max-w-xl mx-auto
}

input{
  @apply mx-auto
}

/*TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out
how to remove the virtical space around the range input in IE*/
@supports (-ms-ime-align: auto) {
  /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */
  input[type="range"] {
    margin: 0;
    /*Edge starts the margin from the thumb, not the track as other browsers do*/
  }
}
</style>